import { AlertDefinitionKey } from "./keys";

export type WidgetSize = "1x1" | "2x1" | "2x2";

export const WidgetKey = {
  TUGGER_1: "tugger1",
  TUGGER_2: "tugger2",
  ENVIRONMENT: "environment",
  ANTICOLLISION: "anticollision",
  LEGCAPACITY: "legcapacity",
  SPEEDLIMITS: "speedlimits",
  BLOCKTRAVEL: "blocktravel",
  GREASING: "greasing",
  MOTIONACC: "motionacc",
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type WidgetKey = (typeof WidgetKey)[keyof typeof WidgetKey];

export interface WidgetDefinition {
  key: WidgetKey;
  label: string;
  icon: string;
  placeholders: Partial<Record<WidgetSize, string>>;
}

export const widgetsCatalog: Record<WidgetKey, WidgetDefinition> = {
  [WidgetKey.TUGGER_1]: {
    key: WidgetKey.TUGGER_1,
    label: "Load tugger 1",
    icon: "/assets/icon-load-tugger.png",
    placeholders: { "1x1": "/assets/widgets/load-tugger-1-1.png" },
  },
  [WidgetKey.TUGGER_2]: {
    key: WidgetKey.TUGGER_2,
    label: "Load tugger 2",
    icon: "/assets/icon-load-tugger.png",
    placeholders: { "1x1": "/assets/widgets/load-tugger-1-1.png" },
  },
  [WidgetKey.ENVIRONMENT]: {
    key: WidgetKey.ENVIRONMENT,
    label: "Environment",
    icon: "/assets/icon-environment.png",
    placeholders: { "2x1": "/assets/widgets/environment-2-1.png" },
  },
  [WidgetKey.ANTICOLLISION]: {
    key: WidgetKey.ANTICOLLISION,
    label: "Anti-collision",
    icon: "/assets/icon-anti-collision.png",
    placeholders: {
      "2x1": "/assets/widgets/anti-collision-2-1.png",
      "2x2": "/assets/widgets/anti-collision-2-2.png",
    },
  },
  [WidgetKey.LEGCAPACITY]: {
    key: WidgetKey.LEGCAPACITY,
    label: "Leg capacity",
    icon: "/assets/icon-leg-capacity.png",
    placeholders: {
      "2x1": "/assets/widgets/leg-capacity-2-1.png",
      "2x2": "/assets/widgets/leg-capacity-2-2.png",
    },
  },
  [WidgetKey.SPEEDLIMITS]: {
    key: WidgetKey.SPEEDLIMITS,
    label: "Speed limits",
    icon: "/assets/icon-speed-limits.png",
    placeholders: { "1x1": "/assets/widgets/speed-limits-1-1.png" },
  },
  [WidgetKey.BLOCKTRAVEL]: {
    key: WidgetKey.BLOCKTRAVEL,
    label: "Block travel",
    icon: "/assets/icon-block-travel.png",
    placeholders: { "1x1": "/assets/widgets/block-travel-1-1.png" },
  },
  [WidgetKey.GREASING]: {
    key: WidgetKey.GREASING,
    label: "Greasing",
    icon: "/assets/icon-greasing.png",
    placeholders: { "1x1": "/assets/widgets/greasing-1-1.png" },
  },
  [WidgetKey.MOTIONACC]: {
    key: WidgetKey.MOTIONACC,
    label: "Motion acc.",
    icon: "/assets/icon-motion-acc.png",
    placeholders: { "1x1": "/assets/widgets/motion-acc-1-1.png" },
  },
};

export const getPlaceholderForSize = (
  key: WidgetKey,
  size: WidgetSize
): string | null => {
  const def = widgetsCatalog[key];
  if (!def) return null;
  return def.placeholders[size] || null;
};

// Optional mapping of alerts that suggest adding a specific widget
export const alertWidgetSuggestions: Partial<
  Record<AlertDefinitionKey, WidgetKey>
> = {
  [AlertDefinitionKey.HIGH_WIND_SPEED]: WidgetKey.ENVIRONMENT,
  [AlertDefinitionKey.OVERLOAD_PROTECTION]: WidgetKey.SPEEDLIMITS,
};
